/**
 * `BuildingTile`'s sprite render-box cap (DS-26), pulled into its own file so
 * `surfaceLayout.ts`'s `surfacePlotAvoidRects` (DS-29 issue #227) can import
 * just these two numbers without importing `BuildingTile.tsx` itself.
 *
 * `BuildingTile.tsx` imports real building icon assets; pulling it into
 * `surfaceLayout.ts` broke Playwright's Node-side spec transform the moment
 * a spec imported `surfaceLayout.ts` directly (as `planet-surface-tiles.spec.ts`
 * already did) — there's no Vite asset pipeline there to resolve a PNG
 * import through, so esbuild tried to parse the PNG's bytes as JS.
 */

// Sized against `PlotTile`'s 150px-wide plot: at 230px a building overflowed
// its own plot by half again, so the surface read as buildings dropped onto
// the ground rather than standing on their plots.
export const BUILDING_SPRITE_WIDTH = 178;
export const BUILDING_SPRITE_HEIGHT = 194;
